import { DetailedHTMLProps, HTMLAttributes } from 'react'
import classNames from 'classnames'
import { ReactFCC } from '@/types/react'

export const PageSection: ReactFCC<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <section
      className={classNames('border-core-gray-300 flex w-full flex-col gap-4 rounded-lg border p-6', className)}
      {...props}
    >
      {children}
    </section>
  )
}
